import React from 'react';

function CardIcon5() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      viewBox="0 0 38 25"
      fill="none"
    >
      <g clipPath="url(#clip0_2_8248)">
        <rect
          width="38"
          height="24"
          transform="translate(0 0.600098)"
          fill="#FF8A00"
        />
        <path
          opacity="0.07"
          d="M35 0.600098H3C1.3 0.600098 0 1.9001 0 3.6001V21.6001C0 23.3001 1.4 24.6001 3 24.6001H35C36.7 24.6001 38 23.3001 38 21.6001V3.6001C38 1.9001 36.6 0.600098 35 0.600098Z"
          fill="black"
        />
        <path
          d="M35 1.6001C36.1 1.6001 37 2.5001 37 3.6001V21.6001C37 22.7001 36.1 23.6001 35 23.6001H3C1.9 23.6001 1 22.7001 1 21.6001V3.6001C1 2.5001 1.9 1.6001 3 1.6001H35Z"
          fill="#D64D00"
        />
        <path
          d="M3.57 7.7601H2V13.2601H3.57C4.4 13.2601 5 13.0601 5.53 12.6301C6.16 12.1101 6.53 11.3301 6.53 10.5201C6.52 8.8901 5.31 7.7601 3.57 7.7601ZM4.83 11.9001C4.49 12.2001 4.06 12.3401 3.36 12.3401H3.07V8.7001H3.36C4.05 8.7001 4.47 8.8201 4.83 9.1401C5.2 9.4701 5.42 9.9801 5.42 10.5101C5.42 11.0401 5.2 11.5701 4.83 11.9001ZM7.02 7.7601H8.09V13.2601H7.02V7.7601ZM10.71 9.8701C10.07 9.6301 9.88 9.4701 9.88 9.1801C9.88 8.8301 10.22 8.5701 10.68 8.5701C11 8.5701 11.27 8.7001 11.54 9.0201L12.1 8.2901C11.64 7.8901 11.09 7.6801 10.48 7.6801C9.51 7.6801 8.76 8.3601 8.76 9.2601C8.76 10.0201 9.11 10.4101 10.11 10.7701C10.53 10.9201 10.74 11.0201 10.85 11.0801C11.06 11.2201 11.17 11.4201 11.17 11.6501C11.17 12.1001 10.82 12.4301 10.34 12.4301C9.83 12.4301 9.42 12.1701 9.17 11.7001L8.48 12.3701C8.97 13.1001 9.57 13.4201 10.38 13.4201C11.49 13.4201 12.28 12.6801 12.28 11.6101C12.3 10.7201 11.93 10.3201 10.71 9.8701ZM12.63 10.5201C12.63 12.1401 13.9 13.3901 15.53 13.3901C15.99 13.3901 16.39 13.3001 16.87 13.0701V11.8101C16.44 12.2401 16.06 12.4101 15.58 12.4101C14.5 12.4101 13.73 11.6301 13.73 10.5101C13.73 9.4501 14.52 8.6201 15.53 8.6201C16.04 8.6201 16.43 8.8001 16.87 9.2401V7.9801C16.4 7.7401 16.01 7.6401 15.55 7.6401C13.94 7.6401 12.63 8.9201 12.63 10.5201ZM25.39 11.4601L23.92 7.7601H22.75L25.08 13.4001H25.66L28.03 7.7601H26.87L25.39 11.4601ZM28.52 13.2601H31.56V12.3301H29.59V10.8501H31.49V9.9201H29.59V8.7001H31.56V7.7601H28.52V13.2601ZM35.81 9.3901C35.81 8.3601 35.1 7.7701 33.86 7.7701H32.27V13.2701H33.34V11.0601H33.48L34.96 13.2701H36.28L34.55 10.9501C35.36 10.7801 35.81 10.2301 35.81 9.3901ZM33.65 10.3001H33.34V8.6301H33.67C34.34 8.6301 34.7 8.9101 34.7 9.4501C34.7 10.0001 34.34 10.3001 33.65 10.3001Z"
          fill="#FF8A00"
        />
        <path
          d="M20.16 13.4601C20.9374 13.4601 21.6829 13.1513 22.2325 12.6016C22.7822 12.052 23.091 11.3064 23.091 10.5291C23.091 9.75175 22.7822 9.00624 22.2325 8.45657C21.6829 7.9069 20.9374 7.5981 20.16 7.5981C19.3827 7.5981 18.6371 7.9069 18.0875 8.45657C17.5378 9.00624 17.229 9.75175 17.229 10.5291C17.229 11.3064 17.5378 12.052 18.0875 12.6016C18.6371 13.1513 19.3827 13.4601 20.16 13.4601Z"
          fill="#FF8A00"
        />
        <path
          d="M36.57 8.1061C36.57 8.0061 36.5 7.9561 36.39 7.9561H36.23V8.4361H36.35V8.2461L36.49 8.4361H36.63L36.47 8.2361C36.53 8.2261 36.57 8.1761 36.57 8.1061ZM36.37 8.1761H36.35V8.0461H36.37C36.43 8.0461 36.46 8.0661 36.46 8.1061C36.46 8.1561 36.43 8.1761 36.37 8.1761Z"
          fill="#231F20"
        />
        <path
          d="M36.41 7.7761C36.18 7.7761 35.99 7.9661 35.99 8.1961C35.99 8.4261 36.18 8.6161 36.41 8.6161C36.64 8.6161 36.83 8.4261 36.83 8.1961C36.83 7.9661 36.64 7.7761 36.41 7.7761ZM36.41 8.5461C36.23 8.5461 36.07 8.3961 36.07 8.1961C36.07 8.0061 36.22 7.8461 36.41 7.8461C36.59 7.8461 36.74 8.0061 36.74 8.1961C36.74 8.3861 36.59 8.5461 36.41 8.5461Z"
          fill="#231F20"
        />
        <path
          d="M37 13.5841C37 13.5841 27.09 20.4731 8.976 23.6001H34.999C35.5267 23.6001 36.033 23.3916 36.4076 23.02C36.7822 22.6484 36.9948 22.1438 36.999 21.6161L37.023 18.5961L37 13.5841Z"
          fill="#FF8A00"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_8248">
          <rect
            width="38"
            height="24"
            fill="white"
            transform="translate(0 0.600098)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon5;
